<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.name"
        placeholder="请输入众筹名称"
        clearable
        size="small"
        class="param-input"
      >
      </el-input>
      <el-input
        v-model="params.cid"
        placeholder="请输入众筹对象ID"
        clearable
        size="small"
        class="param-input"
      >
      </el-input>
      <el-select
        placeholder="请选择是否开启"
        clearable
        size="small"
        v-model="params.enabled"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择众筹状态"
        clearable
        size="small"
        v-model="params.type"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in types"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="background"
        label="背景图"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.background">背景图</span>
          <div
            v-else
            class="picturePreview"
            @click="
              handlePictureCardPreview({ url: imgUrl + scope.row.background })
            "
          >
            <el-image
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.background"
              fit="fill"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="众筹名称" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coins" label="金币" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.coins || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="originalCoins"
        label="订阅原价金币"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.originalCoins }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="众筹状态" align="center" width="110">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1"
            >众筹进行中</el-tag
          >
          <el-tag v-else-if="scope.row.status == 2">众筹已完成</el-tag>
          <el-tag type="warning" v-else-if="scope.row.status == 3"
            >众筹失败</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="cid" label="众筹对象ID" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.cid || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cid" label="众筹对象" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.contentDetail.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="portrait"
        label="众筹对象头像"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.contentDetail.portrait">背景图</span>
          <div
            v-else
            class="picturePreview"
            @click="
              handlePictureCardPreview({
                url: imgUrl + scope.row.contentDetail.portrait,
              })
            "
          >
            <el-image
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.contentDetail.portrait"
              fit="fill"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.enabled">上架</el-tag>
          <el-tag v-else>下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortCode" label="排序" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="startedAt" label="开始时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.startedAt || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="endAt" label="结束时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.endAt || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt || "-") }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="320"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
          >
            删除
          </el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="reactive(scope.row)"
          >
            重新上架
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1100px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <div class="itemBox">
          <el-form-item
            size="small"
            label="众筹名称:"
            prop="name"
            style="width: 480px"
          >
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="启用/禁用:"
            prop="enabled"
            style="width: 480px"
          >
            <el-select v-model="form.enabled" placeholder="请选择">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in statuses"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="众筹对象ID:"
            prop="cid"
            style="width: 480px"
          >
            <el-input v-model="form.cid"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="总参与人数:"
            prop="totalCount"
            style="width: 480px"
          >
            <el-input v-model.number="form.totalCount"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="开始时间:"
            prop="startTime"
            style="width: 480px"
          >
            <el-date-picker
              type="date"
              v-model="form.startTime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            size="small"
            label="结束时间:"
            prop="endTime"
            style="width: 480px"
          >
            <el-date-picker
              type="date"
              v-model="form.endTime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item size="small" label="背景图:" prop="background">
            <base-upload
              :cover="form.background"
              :action="uploadUrl"
              @successCallback="uploadCoverThumb"
              :width="'180px'"
              :height="'90px'"
              :hide="true"
            ></base-upload>
          </el-form-item>
          <el-form-item
            size="small"
            label="排序:"
            prop="sortCode"
            style="width: 480px"
          >
            <el-input v-model.number="form.sortCode"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="参与金币:"
            prop="coins"
            style="width: 480px"
          >
            <el-input v-model.number="form.coins"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="订阅原价金币:"
            prop="originalCoins"
            style="width: 480px"
          >
            <el-input v-model.number="form.originalCoins"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="排序:"
            prop="sortCode"
            style="width: 480px"
          >
            <el-input v-model.number="form.sortCode"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="奖励时长:"
            prop="rewardTime"
            style="width: 480px"
          >
            <el-input v-model.number="form.rewardTime"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="描述:"
            prop="description"
            style="width: 960px"
          >
            <el-input type="textarea" v-model="form.description"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog
      title="重新上架"
      :visible.sync="reactiveDialogVisible"
      width="1100px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <div class="itemBox">
          <el-form-item
            size="small"
            label="总参与人数:"
            prop="totalCount"
            style="width: 480px"
          >
            <el-input v-model.number="form.totalCount"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="开始时间:"
            prop="startTime"
            style="width: 480px"
          >
            <el-date-picker
              type="date"
              v-model="form.startTime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            size="small"
            label="结束时间:"
            prop="endTime"
            style="width: 480px"
          >
            <el-date-picker
              type="date"
              v-model="form.endTime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="参与金币:"
            prop="coins"
            style="width: 480px"
          >
            <el-input v-model.number="form.coins"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="订阅原价金币:"
            prop="originalCoins"
            style="width: 480px"
          >
            <el-input v-model.number="form.originalCoins"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="排序:"
            prop="sortCode"
            style="width: 480px"
          >
            <el-input v-model.number="form.sortCode"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="奖励时长:"
            prop="rewardTime"
            style="width: 480px"
          >
            <el-input v-model.number="form.rewardTime"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onReactive()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 封面上传地址
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      imgUrl: baseConfig.imgUrl,
      fileList: [], // 用于编辑图片回显
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        cid: undefined, // CID
        name: undefined, // 名称
        status: undefined, // 状态
      },
      rules: {
        name: [{ required: true, message: "请输入众筹名称", trigger: "blur" }],
        enabled: [
          { required: true, message: "请选择众筹状态", trigger: "blur" },
        ],
        cid: [
          { required: true, message: "请输入众筹对象CID", trigger: "blur" },
        ],
        totalCount: [
          { required: true, message: "请输入总参与人数", trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请选择众筹开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请选择众筹结束时间", trigger: "blur" },
        ],
        rewardTime: [
          { required: true, message: "请输入奖励时长", trigger: "blur" },
        ],
        coins: [{ required: true, message: "请选择参与金币", trigger: "blur" }],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" },
        ],
        background: [
          { required: true, message: "请上传背景图", trigger: "blur" },
        ],
      },
      types: [
        {
          label: "众筹进行中",
          value: 1,
        },
        {
          label: "众筹已完成",
          value: 2,
        },
        {
          label: "众筹失败",
          value: 3,
        },
      ],
      statuses: [
        {
          label: "启用",
          value: true,
        },
        {
          label: "禁用",
          value: false,
        },
      ],
      dialogTitle: "",
      dialogVisible: false,
      reactiveDialogVisible: false,
      initialName: undefined, // 初始众筹名称(用于校验是否修改过值)
      form: {
        id: undefined,
        name: undefined, // 众筹名称
        cid: undefined, // 众筹对象ID
        background: undefined, // 背景图
        description: undefined, // 描述
        sortCode: undefined, // 排序
        totalCount: undefined, // 总参与人数
        coins: undefined, // 参与金币
        rewardTime: undefined, // 奖励时长
        startTime: undefined, // 众筹开始时间
        endTime: undefined, // 众筹结束时间
        enabled: undefined, //启用/禁用
        originalCoins: undefined, //订阅原价金币
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 背景图上传成功
    uploadCoverThumb(res) {
      this.form.background = res.data.coverImg;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getCrowdFundingList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增众筹
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.initialName = JSON.parse(JSON.stringify(param.name));
        this.form.background = param.background;
        this.form.cid = param.cid;
        this.form.totalCount = param.totalCount;
        this.form.description = param.description;
        this.form.sortCode = param.sortCode;
        this.form.coins = param.coins;
        this.form.rewardTime = param.rewardTime;
        this.form.startTime = param.startedAt;
        this.form.endTime = param.endAt;
        this.form.enabled = param.enabled;
        this.form.originalCoins = param.originalCoins;
        console.log(param);
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    reactive(param) {
      this.form.id = param.id;
      this.form.totalCount = param.totalCount;
      this.form.sortCode = param.sortCode;
      this.form.coins = param.coins;
      this.form.rewardTime = param.rewardTime;
      this.form.startTime = param.startedAt;
      this.form.endTime = param.endAt;
      this.form.originalCoins = param.originalCoins;
      this.reactiveDialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addCrowdFunding(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.initialName == this.form.name) this.form.name = undefined;
          API.updateCrowdFunding(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    onReactive() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.initialName == this.form.name) this.form.name = undefined;
          API.reactiveCrowdFunding(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "重新上架成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "重新上架失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delCrowdFunding(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = undefined;
      this.initialName = undefined;
      this.form.background = undefined;
      this.form.cid = undefined;
      this.form.totalCount = undefined;
      this.form.description = undefined;
      this.form.sortCode = undefined;
      this.form.coins = undefined;
      this.form.rewardTime = undefined;
      this.form.startTime = undefined;
      this.form.endTime = undefined;
      this.form.originalCoins = undefined;
      this.dialogVisible = false;
      this.reactiveDialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
.itemBox {
  display: flex;
  justify-content: space-between;
}
</style>
